import { format } from 'date-fns';
import { useState } from 'react';
import {
  SearchDate,
  SearchDateRange,
} from '../../../../common/components/SearchHeader/types/FilterChoice';
import { now } from '../../../../common/util/now';
import { CalendarView } from '../../../CalendarView/CalendarView';
import { FilterActions } from '../FilterActions';

type Props = {
  date?: SearchDateRange;
  onReset: VoidFunction;
  onApply: (date: SearchDate | undefined) => void;
};

export const DateFilterRange = ({ date, onReset, onApply }: Props) => {
  const startDate = date ? date.start : format(now(), 'yyyy-MM-dd');
  const endDate = date && date.end;

  const [start, setStart] = useState<string>(startDate);
  const [end, setEnd] = useState<string | undefined>(endDate);

  const handleStart = (value: Date) => {
    const selectedDate = format(value, 'yyyy-MM-dd');

    if (start && !end && selectedDate > start) {
      setEnd(selectedDate);
    } else {
      setEnd(undefined);
      setStart(selectedDate);
    }
  };

  return (
    <>
      <CalendarView
        value={new Date(start)}
        endValue={end ? new Date(end) : undefined}
        onChange={handleStart}
        disableWhitelist
      />

      <FilterActions onReset={onReset} onApply={() => onApply({ start, end })} />
    </>
  );
};
